import moment from 'moment'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { mainport } from 'src/constants'
import { Documents } from 'src/containers/gener-s2/bricks/documents'
import { SAGA_GUARDS, TO_INTRO_S0 } from 'src/navigation'
import { shoot } from 'src/redux/actions'
import {
  select_company,
  select_formik_item,
  select_loading,
  select_start_date,
} from 'src/redux/store'
import { button_t, fitem_t, formshell_t } from 'src/types'
import { is_valorized } from 'src/utils'
import { StepDirector } from 'src/widgets/step-director/step-director'

import { Button } from '../button/button'
import { FormSet } from '../form-set/form-set'
import { Loader } from '../loader/loader'

export const FormShell: FC<formshell_t> = ({
  step,
  look = '',
  title,
  subtitle,
  divider,
  back = true,
  fired = false,
  disabled,
  children,
  to_page,
  on_change_look,
  on_change,
  on_submit,
}: formshell_t) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const on_submit_ =
    on_submit ||
    (({ fpool, valid }) => {
      if (valid && to_page) {
        // if (find_fitem(fpool, 'is1__vehicle_type')?.capture === 'tcm') {
        //   window.open(
        //     'https://perloro.itasmia.it/it/famiglia/wizard/?utm_source=preventivatore',
        //     '_blank'
        //   )
        // } else if (find_fitem(fpool, 'is1__vehicle_type')?.capture === 'ltc') {
        //   window.open(
        //     'https://permedomani.itasmia.it/it/wizard/?utm_source=preventivatore',
        //     '_blank'
        //   )
        // } else {
        navigate(to_page(fpool))
        // }
      }
    })

  /**
   * Use Selector
   */
  const loading_fs = useSelector(
    select_loading([SAGA_GUARDS.FPOOL_SPECIAL, SAGA_GUARDS.VEHICLE_BRANDS])
  )
  const loading_vh = useSelector(
    select_loading([SAGA_GUARDS.VEHICLE_MODELS, SAGA_GUARDS.VEHICLE_VERSIONS])
  )

  // const loading_qdr = useSelector(
  //   select_loading([SAGA_GUARDS.MOP_QUATTRO_RUOTE, SAGA_GUARDS.MOP_DUE_RUOTE])
  // )

  const company = useSelector(select_company)?.key
  const product = useSelector(select_formik_item('ts1a__vehicle_type'))?.capture
  const start_date = useSelector(select_start_date)

  /**
   * Use State
   */
  const [look_, set_look] = useState(look)
  const [fpool_, set_fpool] = useState<fitem_t[]>([])
  const [fired_, set_fired] = useState(false)
  const [valid_, set_valid] = useState(false)
  const [gtm_class_, set_gtm_class] = useState<string | undefined>()
  const [visible_docs, set_visible_docs] = useState(false)

  /**
   * Use Effect
   */
  useEffect(() => {
    on_change_look?.(look_)
  }, [look_])

  /**
   * Render functions
   */
  const render_divider = () => (
    <div className={mainport}>
      <hr className="mt-5 mb-4" />
    </div>
  )

  const render_head = () => {
    const btn: button_t = {
      flavor: 'primary_flip',
      classes: 'mt-sm-0 mt-3 p-0 float-right',
    }
    return (
      <div
        className={`${mainport} ${
          title ? 'py-5' : ''
        } d-sm-flex align-items-center justify-content-between`}
      >
        {/* TITLE */}
        {title && <p className="m-0 p-0 font-48 col-xl-9">{title}</p>}

        {/* SUBTITLE */}
        {subtitle && <p className="m-0 p-0 font-20 c-7f7f7f">{subtitle}</p>}

        {/* BUTTONS */}
        {step !== 'ts1a' && (
          <>
            {look_ === 'edit' && (
              <Button {...btn} text={'Modificare'} on_press={() => set_look('save')} />
            )}
            {look_ === 'save' && (
              <Button {...btn} text={'Salvare'} on_press={() => set_look('edit')} />
            )}
          </>
        )}
      </div>
    )
  }

  const render_loaders = () => (
    <>
      <Loader hidden={!loading_fs} />
      {/* <Loader hidden={!loading_qdr} /> */}
      <Loader hidden={!(loading_vh && step === 'ts2') || loading_fs} overlay={true} />
    </>
  )

  const render_formset = () => {
    return (
      !loading_fs && (
        // !loading_qdr &&
        <FormSet
          step={step}
          fired={fired}
          disabled={look_ === 'edit'}
          on_submit={on_submit_}
          on_change={({ fpool, fired, valid, gtm_class }) => {
            set_fpool(fpool)
            set_fired(fired)
            set_valid(valid)
            set_gtm_class(gtm_class)
            on_change?.({ fpool, fired, valid, gtm_class })
          }}
        />
      )
    )
  }

  const render_step_director = () => (
    <div className="col-12">
      <StepDirector
        on_back={back ? () => navigate(-1) : undefined}
        next_disabled={is_valorized(disabled) ? disabled : fired_ && !valid_}
        form_id={`form-${step}`}
        gtm_class={is_valorized(gtm_class_) ? gtm_class_ : ''}
      />
    </div>
  )

  const render_information_set = () => (
    <div className="col-12 mt-5 d-flex">
      <span className="font-16 c-7f7f7f">{`${t('ts2.information_set')} `}</span>
      <Button
        flavor="primary_flip"
        text={t('gs2.car_documents')}
        classes="m-0 ml-1 p-0"
        on_press={() => {
          set_visible_docs(true)
          dispatch(
            shoot.saga_resolve_otherdocs({
              codComp: company,
              codRamo: '50',
              codProd: product?.split('-')[0],
              dataDecorrenza: moment(start_date).format('YYYY-MM-DD'),
              sector: product?.split('-')[1],
            })
          )
        }}
      />
      <Documents visible={visible_docs} on_close={() => set_visible_docs(false)} />
    </div>
  )

  return (
    <main className={look === '' ? 'mb-lg-100 mt-lg-50' : ''}>
      {render_head()}
      {render_loaders()}

      <div hidden={loading_fs}>
        {render_formset()}
        {children?.({ fpool: fpool_, fired: fired_, valid: valid_ })}
        {divider && step === 'ts1a' && (
          <p className="mt-2 font-16 c-7f7f7f col-xl-7">
            {`${t('gs1.new_request_required')} `}
            <u className="c-primary text-lowercase" onClick={() => navigate(TO_INTRO_S0)}>
              {t('commons.click_here')}
            </u>
          </p>
        )}

        {look === '' && render_step_director()}
        {step === 'ts2' && render_information_set()}
        {step === 'ts3' && render_information_set()}
        {step === 'ts4' && render_information_set()}
        {step === 'ts5' && render_information_set()}
      </div>

      {divider && render_divider()}
    </main>
  )
}
